import { axiosInstance } from '../Config/axios';

const API_URL = 'v1/controls/';
const API_DELETED_URL = `v1/controls-deleted/`;
const CONFIG_URL = 'v1/areas/';

// Función para obtener la lista de controles (GET)
export const getControls = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los controles:", error);
    throw error;
  }
};

// Obtener una activo por código
export const getControlsByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el control con código ${code}:`, error);
    throw error;
  }
};

// Función para crear un nuevo control (POST)
export const createControl = async (data) => {
  try {
    const response = await axiosInstance.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error("Error al crear el control:", error);
    throw error;
  }
};

// Función para actualizar un control (PUT)
export const updateControl = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}${id}/`, data);
    return response.data;
  } catch (error) {
    console.error("Error al actualizar el control:", error);
    throw error;
  }
};

// Función para eliminar un control (DELETE)
export const deleteControl = async (id) => {
  try {
    await axiosInstance.delete(`${API_URL}${id}/`);
  } catch (error) {
    console.error("Error al eliminar el control:", error);
    throw error;
  }
};

// AREA

// Obtener las areas de controles
export const getControlsArea = async (source) => {
  try {
    const response = await axiosInstance.get(CONFIG_URL, {
      params: { source },
    });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener las áreas (${source}):`, error);
    throw error;
  }
};

// Obtener un area de control en particular
/* export const getControlsAreaById = async (id) => {
  try {
    const response = await axiosInstance.get(`${CONFIG_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el area de control con ID ${id}:`, error);
    throw error;
  }
}; */

// Crear una nueva area
/* export const createControlsArea = async (data) => {
  try {
    const response = await axiosInstance.post(CONFIG_URL, data);
    return response.data;
  } catch (error) {
    console.error("Error al crear una nueva area", error);
    throw error;
  }
}; */

// Actualizar una area de control
/* export const updateControlsArea = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${CONFIG_URL}${id}/`, data);
    return response.data;
  } catch (error) {
    console.error("Error al actualizar el area de control", error);
    throw error;
  }
}; */

// Eliminar una area de control
/* export const deleteControlsArea = async (id) => {
  try {
    const response = await axiosInstance.delete(`${CONFIG_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error al eliminar una area de control", error);
    throw error;
  }
}; */

// OBTENER CATEOGIRAS, PRIORIDAD, FRAMEWORKS, TIPO Y RIESGOS

// Función para obtener categorias (GET)
export const getCategories = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}config/categories/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener categorías:", error);
    throw error;
  }
};

// Función para obtener las prioridades (GET)
export const getPriorities = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}config/priorities/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener prioridades:", error);
    throw error;
  }
};

// Función para obtener los frameworks (GET)
export const getFrameworks = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}config/frameworks/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener frameworks:", error);
    throw error;
  }
};

// Función para obtener los tipos (GET)
export const getTypes = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}config/types/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los tipos:", error);
    throw error;
  }
};

// Función para obtener los riesgos (GET)
export const getRisks = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}config/risks/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los riesgos:", error);
    throw error;
  }
};

// Función para listar los controles eliminados (GET)
export const getControlsDeleted = async () => {
  try {
    const response = await axiosInstance.get(API_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los controles eliminados:', error);
    throw error;
  }
};

// Obtener una activo eliminado por código (GET)
export const getControlsDeletedByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_DELETED_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el control eliminado con código ${code}:`, error);
    throw error;
  }
};